import React from 'react';
import {
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AiProviderIconStack from '../Workspaces/AiProviderIconStack';
import DataEnrichmentIdentityIcon from './DataEnrichmentIdentityIcon';

const AI_LOGO_CARD_SIZE = 27;
const AI_LOGO_MARK_SIZE = 14;
const AI_LOGO_OVERLAP = -10;
const DATA_ENRICHMENT_ACTION_ICON_SIZE = 40;

export default function SpreadsheetActionsRootView({ onClose, onViewChange, theme }) {
  const iconColumnWidth = AI_LOGO_CARD_SIZE + 2 * (AI_LOGO_CARD_SIZE + AI_LOGO_OVERLAP);
  const actionItemSx = {
    display: 'grid',
    gridTemplateColumns: `${iconColumnWidth}px minmax(0, 1fr)`,
    columnGap: 0.75,
    alignItems: 'center',
    py: 0.7,
    px: 0.75,
    minHeight: 0,
    borderRadius: '8px',
    '&:hover': {
      bgcolor: theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,0.06)'
        : 'rgba(88,89,91,0.06)',
    },
  };

  const renderActionCopy = (title, description) => (
    <ListItemText
      sx={{ m: 0, minWidth: 0 }}
      primary={(
        <Typography variant="body2" sx={{ fontWeight: 600, fontSize: 13, lineHeight: 1.25 }}>
          {title}
        </Typography>
      )}
      secondary={description}
      secondaryTypographyProps={{
        sx: { fontSize: '11.5px', mt: 0.2, lineHeight: 1.35, color: 'text.secondary' },
      }}
    />
  );

  return (
    <Box
      data-testid="spreadsheet-actions-menu-v4"
      sx={{ width: 'min(420px, calc(100vw - 32px))', p: 0.5, '--ai-provider-overlap': `${AI_LOGO_OVERLAP}px` }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, px: 0.75, py: 0.35 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: 13.5, lineHeight: 1.2 }}>
          Actions
        </Typography>
        <Box sx={{ flex: 1 }} />
        <IconButton size="small" onClick={onClose} aria-label="Close actions" sx={{ p: 0.35 }}>
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Box>
      <Divider sx={{ mx: 0.5 }} />
      <List disablePadding sx={{ display: 'flex', flexDirection: 'column', gap: 0.2, pt: 0.35, pb: 0.25, px: 0.15 }}>
        <ListItem button onClick={() => onViewChange('useAi')} sx={actionItemSx}>
          <Box
            data-testid="actions-ai-logo-slot"
            sx={{
              width: iconColumnWidth,
              height: AI_LOGO_CARD_SIZE,
              flexShrink: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              overflow: 'visible',
            }}
          >
            <AiProviderIconStack
              interactive={false}
              dense
              flat
              cardSize={AI_LOGO_CARD_SIZE}
              logoSize={AI_LOGO_MARK_SIZE}
            />
          </Box>
          {renderActionCopy(
            'Use AI Agent',
            'Search our database, browse the web, and analyze data with our AI agent.'
          )}
        </ListItem>
        <ListItem button onClick={() => onViewChange('dataEnrichment')} sx={actionItemSx}>
          <Box
            data-testid="data-enrichment-action-icon"
            sx={{
              width: iconColumnWidth,
              height: DATA_ENRICHMENT_ACTION_ICON_SIZE,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <DataEnrichmentIdentityIcon size={DATA_ENRICHMENT_ACTION_ICON_SIZE} />
          </Box>
          {renderActionCopy(
            'Data Enrichment',
            'Find people, discover & verify emails using external providers.'
          )}
        </ListItem>
      </List>
    </Box>
  );
}
